<!--suppress JSUnresolvedVariable -->
<template>
    <div>
        <div ref="shoppingWizardModal">
            <div class="modal fade">
                <div class="modal-dialog modal-lg" role="document">
                    <form class="modal-content" method="post" @submit.prevent  v-if="itemId">
                        <div class="modal-header h3">
                            <div class="modal-title" v-if="itemData">{{ itemData.texts.name2 }}</div>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">

                            <div class="container-fluid" v-if="itemData">
                                <div class="row">
                                    <div class="col-sm-6">

                                        <img :src="previewImageUrl" class="img-fluid">
                                        <p class="d-block text-right">{{
                                            "ShoppingWizard::Template.priceWithCustomization" | translate }}</p>
                                        <span class="price h1 d-block  text-right">
                                            <span content="74.9">
                                             {{ currentPrice | currency }}
                                            </span><sup>*</sup>
                                        </span>

                                        <span class="vat small text-muted d-block  text-right">
                                            {{ "ShoppingWizard::Template.priceIncludingVatAndShipping" | translate }}
                                        </span>
                                    </div>


                                    <!-- property selection -->
                                    <div class="col-sm-6">

                                        <shopping-wizard-properties
                                                v-model="selectedProperties"
                                                v-on:is-valid="updateValidState($event)"
                                                v-on:update-surcharge="updateSurcharge($event)"
                                                v-on:set-preview-img="updatePreviewImage($event)"
                                                :properties="itemData.properties"
                                                :configuration="configuration"></shopping-wizard-properties>

                                    </div>
                                </div>


                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="submit" :disabled="!isValid || waiting"
                                    class="btn btn-primary btn-appearance "
                                    @click="addToBasket()">
                                <i class="fa fa-check" aria-hidden="true"></i>
                                <span>{{ "ShoppingWizard::Template.addToBasket" | translate }}</span>
                            </button>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<!--suppress EqualityComparisonWithCoercionJS -->
<script>
    import ModalService from "../services/ModalService";
    import {EventBus} from "../event-bus";

    export default {
        props: {
            configuration: Object,
        },
        computed: {
            itemData() {
                if(this.itemId){
                    return this.$store.getters[`${this.itemId}/currentItemVariation`];
                }
                return {};
            }
        },
        data() {
            return {
                previewImageUrl: '',
                shoppingWizardModal: {},
                currentPrice: 0.00,
                isValid: false,
                itemId: null,
                waiting: false,

                selectedProperties: {
                    selectedGroupId: 0,

                    selectedBrandingTypeId: 0,
                    initials: '',

                    selectedAirbrushTypeId: 0,
                    selectedMotiveSelectionId: 0,
                    selectedColorSelectionId: 0,
                },
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.shoppingWizardModal = ModalService.findModal(this.$refs.shoppingWizardModal);
            });


            EventBus.$on('openWizardModal', this.initModal);
        },
        methods: {
            initModal(itemId) {
                this.itemId = itemId;
                this.previewImageUrl = this.itemData.images.all[0].urlMiddle;
                this.currentPrice = this.itemData.prices.default.price.value;
                this.shoppingWizardModal.show();
            },
            resetSelectedProperties() {
                this.selectedProperties = {
                    selectedGroupId: 0,

                    selectedBrandingTypeId: 0,
                    initials: '',

                    selectedAirbrushTypeId: 0,
                    selectedMotiveSelectionId: 0,
                    selectedColorSelectionId: 0,
                };
            },
            updateValidState(state) {
                this.isValid = state;
            },
            updateSurcharge(totalSurcharge) {
                this.currentPrice = this.itemData.prices.default.price.value + totalSurcharge;
            },
            updatePreviewImage(previewImageUrl) {
                if (previewImageUrl) {
                    this.previewImageUrl = previewImageUrl;
                } else {
                    this.previewImageUrl = this.itemData.images.all[0].urlMiddle;
                }
            },
            getProperty(propertyId) {
                for (let property of this.itemData.properties) {
                    if (property.propertyId == propertyId) {
                        return property;
                    }
                }
                return {};
            },
            addToBasket() {

                this.waiting = true;
                let orderProperties = [];

                if (this.selectedProperties.selectedGroupId == this.configuration.groupIdAirbrush) {

                    if (this.selectedProperties.selectedColorSelectionId != 0) {

                        orderProperties.push(
                            {
                                property: {
                                    ...this.getProperty(this.configuration.airbrush.airbrushTypeIdColor).property,
                                    value: this.selectedProperties.selectedColorSelectionId
                                }
                            }
                        );
                    }

                    if (this.selectedProperties.selectedAirbrushTypeId == this.configuration.airbrush.airbrushTypeIdMotive) {
                        orderProperties.push(
                            {
                                property: {
                                    ...this.getProperty(this.configuration.airbrush.airbrushTypeIdMotive).property,
                                    value: this.selectedProperties.selectedMotiveSelectionId
                                }
                            }
                        );
                    } else if (this.selectedProperties.selectedAirbrushTypeId == this.configuration.airbrush.airbrushTypeIdLetter) {
                        orderProperties.push(
                            {
                                property: {
                                    ...this.getProperty(this.configuration.airbrush.airbrushTypeIdLetter).property,
                                    value: this.selectedProperties.initials.toUpperCase()
                                }
                            }
                        );
                    }

                } else {

                    if (this.selectedProperties.selectedBrandingTypeId == this.configuration.productBranding.brandingTypeIdDefault) {
                        orderProperties.push(
                            {
                                property: {
                                    ...this.getProperty(this.configuration.productBranding.brandingTypeIdDefault).property,
                                    value: this.selectedProperties.initials.toUpperCase()
                                }
                            }
                        );
                    } else if (this.selectedProperties.selectedBrandingTypeId == this.configuration.productBranding.brandingTypeIdSilver) {
                        orderProperties.push(
                            {
                                property: {
                                    ...this.getProperty(this.configuration.productBranding.brandingTypeIdSilver).property,
                                    value: this.selectedProperties.initials.toUpperCase()
                                }
                            }
                        );
                    } else if (this.selectedProperties.selectedBrandingTypeId == this.configuration.productBranding.brandingTypeIdGold) {
                        orderProperties.push(
                            {
                                property: {
                                    ...this.getProperty(this.configuration.productBranding.brandingTypeIdGold).property,
                                    value: this.selectedProperties.initials.toUpperCase()
                                }
                            }
                        );
                    }

                }

                orderProperties.forEach(function (orderProperty) {
                    if (orderProperty.property.valueType === "float" &&
                        !isNullOrUndefined(orderProperty.property.value) &&
                        orderProperty.property.value.slice(-1) === App.decimalSeparator) {
                        orderProperty.property.value = orderProperty.property.value.substr(0, orderProperty.property.value.length - 1);
                    }
                });

                const basketObject =
                    {
                        variationId: this.itemData.variation.id,
                        quantity: 1,
                        basketItemOrderParams: orderProperties
                    };

                this.$store.dispatch("addBasketItem", basketObject).then(
                    response => {
                        document.dispatchEvent(new CustomEvent("afterBasketItemAdded", {detail: basketObject}));
                        this.waiting = false;
                        this.shoppingWizardModal.hide();
                        this.resetSelectedProperties();
                    },
                    error => {
                        this.waiting = false;
                        //console.log('Adding item to basket failed');
                    });
            }
        }
    }
</script>

<style scoped>
    @media only screen and (max-width: 768px) {

    }

</style>



// WEBPACK FOOTER //
// src/components/ShoppingWizardModal.vue